import React from 'react';

import IconDeepResearchText from '@components/Images/DeepResearch/IconDeepResearchText';
import IconArrow from '@components/Images/Rebranding/IconArrow';
import useEventTracking from '@hooks/useEventTracking';
import { deep_research_path } from '@routes';
import { ClickTarget, click } from '@tracking';

const DeepResearchScrollBanner = () => {
  const { trackEvent } = useEventTracking();
  return (
    <a
      href={deep_research_path()}
      className="group absolute right-0 hidden items-center gap-28 bg-grayscale-beige pb-16 pl-20 pr-36 pt-10 [clip-path:polygon(0_0,100%_0,100%_calc(100%-20px),calc(100%-32px)_100%,0_100%)] nav:flex"
      onClickCapture={() =>
        trackEvent(click({ clickTarget: ClickTarget.DeepResearchScrollBanner }))
      }
    >
      <IconDeepResearchText className="w-[160px]" />
      <IconArrow className="w-16 rotate-180 text-primary-magenta transition-transform duration-200 group-hover:translate-x-2" />
    </a>
  );
};

export default DeepResearchScrollBanner;
